/**
 * Ryan O'Dowd
 * 2024-02-08
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Lecture = (props: LectureProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <Text style={styles.lectureText}>{props.text}</Text>{/* @TODO: needs to be editable */}{/* @TODO: doesn't honor newlines */}
    </View>
  );
};

class LectureProps {
  // @TODO: id: PropTypes.number.isRequired,
  // @TODO: created_at: PropTypes.string.isRequired,
  // @TODO: updated_at: PropTypes.string.isRequired,
  text: string; // @TODO: node? should allow for html or other markup
};

export default Lecture;
